import React, { useContext } from "react";
import { SafeAreaView, Text, View, ActivityIndicator } from "react-native";

import AppConfig from "../../../../config/AppConfig";
import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import ExitTutorialsButton from "../../common/header/ExitTutorialsButton";
import headerStyles from "../../common/header/headerStyles";
import Icons from "../../common/icons";
import ReflectionContext from "../../reflection/ReflectionContext";

export default function LastWeekHeader(props) {
  const {
    controller,
    title,
    subTitle,
    isLoading = false,
    returnPage,
    goBack,
    highlightBack = false,
    onJournalIconPress = () => {},
  } = props;

  const { showTutorials, tutorialStep } = useContext(ReflectionContext) || {};
  const hasReturnPage = returnPage || typeof goBack == "function";
  const highlightStyle = tutorialStep == 8 ? appStyles.highlightRound : null;

  const goToMore = () => {
    if (controller != null) {
      if (controller.navigation != null && AppConfig.USE_DRAWER) {
        controller.navigation.openDrawer();
      } else {
        controller.changePage("feed", { selectedPage: "more", args: {} });
      }
    }
  };

  return (
    <SafeAreaView
      style={[
        headerStyles.container,
        { borderBottomLeftRadius: 0, borderBottomRightRadius: 0 },
      ]}
    >
      <View style={headerStyles.header}>
        <View style={headerStyles.leftContainer}>
          {showTutorials || hasReturnPage ? (
            <Icons.Back highlight={highlightBack} onPress={goBack} />
          ) : (
            <Icons.MenuIcon onPress={goToMore} />
          )}
        </View>

        <View style={headerStyles.titleContainer}>
          <Text style={[headerStyles.title]}>{title}</Text>

          {subTitle ? (
            <View style={headerStyles.subTitleContainer}>
              <Text style={headerStyles.subTitle}>{subTitle}</Text>
            </View>
          ) : null}
        </View>

        {/* Exit tutorials */}
        <ExitTutorialsButton controller={controller} />

        <View style={headerStyles.rightContainer}>
          <Icons.Journal
            style={[headerStyles.icon, highlightStyle]}
            onPress={onJournalIconPress}
            width={24}
            height={24}
            fillColor={AppTheme.iconBlack}
          />
          {isLoading ? (
            <ActivityIndicator
              size="large"
              color={AppTheme.DEFAULT_COLOR}
              style={headerStyles.loading}
            />
          ) : null}
        </View>
      </View>
    </SafeAreaView>
  );
}
